// Country → { name, currency, dialCode, flag } used by Signup & Checkout for
// auto-selecting phone country-code + billing currency.
// Not exhaustive; covers the ~40 countries that account for >95% of Optivize traffic.
// Fallback to India when a country is not in the map.

export const COUNTRIES = [
  { code: "IN", name: "India",           currency: "INR", dial: "+91",  flag: "🇮🇳" },
  { code: "US", name: "United States",   currency: "USD", dial: "+1",   flag: "🇺🇸" },
  { code: "GB", name: "United Kingdom",  currency: "GBP", dial: "+44",  flag: "🇬🇧" },
  { code: "CA", name: "Canada",          currency: "CAD", dial: "+1",   flag: "🇨🇦" },
  { code: "AU", name: "Australia",       currency: "AUD", dial: "+61",  flag: "🇦🇺" },
  { code: "AE", name: "United Arab Emirates", currency: "AED", dial: "+971", flag: "🇦🇪" },
  { code: "SG", name: "Singapore",       currency: "SGD", dial: "+65",  flag: "🇸🇬" },
  { code: "DE", name: "Germany",         currency: "EUR", dial: "+49",  flag: "🇩🇪" },
  { code: "FR", name: "France",          currency: "EUR", dial: "+33",  flag: "🇫🇷" },
  { code: "NL", name: "Netherlands",     currency: "EUR", dial: "+31",  flag: "🇳🇱" },
  { code: "IT", name: "Italy",           currency: "EUR", dial: "+39",  flag: "🇮🇹" },
  { code: "ES", name: "Spain",           currency: "EUR", dial: "+34",  flag: "🇪🇸" },
  { code: "IE", name: "Ireland",         currency: "EUR", dial: "+353", flag: "🇮🇪" },
  { code: "BE", name: "Belgium",         currency: "EUR", dial: "+32",  flag: "🇧🇪" },
  { code: "AT", name: "Austria",         currency: "EUR", dial: "+43",  flag: "🇦🇹" },
  { code: "PT", name: "Portugal",        currency: "EUR", dial: "+351", flag: "🇵🇹" },
  { code: "CH", name: "Switzerland",     currency: "CHF", dial: "+41",  flag: "🇨🇭" },
  { code: "SE", name: "Sweden",          currency: "SEK", dial: "+46",  flag: "🇸🇪" },
  { code: "NO", name: "Norway",          currency: "NOK", dial: "+47",  flag: "🇳🇴" },
  { code: "DK", name: "Denmark",         currency: "DKK", dial: "+45",  flag: "🇩🇰" },
  { code: "FI", name: "Finland",         currency: "EUR", dial: "+358", flag: "🇫🇮" },
  { code: "JP", name: "Japan",           currency: "JPY", dial: "+81",  flag: "🇯🇵" },
  { code: "KR", name: "South Korea",     currency: "KRW", dial: "+82",  flag: "🇰🇷" },
  { code: "CN", name: "China",           currency: "CNY", dial: "+86",  flag: "🇨🇳" },
  { code: "HK", name: "Hong Kong",       currency: "HKD", dial: "+852", flag: "🇭🇰" },
  { code: "TW", name: "Taiwan",          currency: "TWD", dial: "+886", flag: "🇹🇼" },
  { code: "MY", name: "Malaysia",        currency: "MYR", dial: "+60",  flag: "🇲🇾" },
  { code: "TH", name: "Thailand",        currency: "THB", dial: "+66",  flag: "🇹🇭" },
  { code: "ID", name: "Indonesia",       currency: "IDR", dial: "+62",  flag: "🇮🇩" },
  { code: "PH", name: "Philippines",     currency: "PHP", dial: "+63",  flag: "🇵🇭" },
  { code: "VN", name: "Vietnam",         currency: "VND", dial: "+84",  flag: "🇻🇳" },
  { code: "NZ", name: "New Zealand",     currency: "NZD", dial: "+64",  flag: "🇳🇿" },
  { code: "ZA", name: "South Africa",    currency: "ZAR", dial: "+27",  flag: "🇿🇦" },
  { code: "BR", name: "Brazil",          currency: "BRL", dial: "+55",  flag: "🇧🇷" },
  { code: "MX", name: "Mexico",          currency: "MXN", dial: "+52",  flag: "🇲🇽" },
  { code: "AR", name: "Argentina",       currency: "ARS", dial: "+54",  flag: "🇦🇷" },
  { code: "SA", name: "Saudi Arabia",    currency: "SAR", dial: "+966", flag: "🇸🇦" },
  { code: "QA", name: "Qatar",           currency: "QAR", dial: "+974", flag: "🇶🇦" },
  { code: "KW", name: "Kuwait",          currency: "KWD", dial: "+965", flag: "🇰🇼" },
  { code: "BH", name: "Bahrain",         currency: "BHD", dial: "+973", flag: "🇧🇭" },
  { code: "OM", name: "Oman",            currency: "OMR", dial: "+968", flag: "🇴🇲" },
  { code: "TR", name: "Turkey",          currency: "TRY", dial: "+90",  flag: "🇹🇷" },
  { code: "IL", name: "Israel",          currency: "ILS", dial: "+972", flag: "🇮🇱" },
  { code: "EG", name: "Egypt",           currency: "EGP", dial: "+20",  flag: "🇪🇬" },
  { code: "NG", name: "Nigeria",         currency: "NGN", dial: "+234", flag: "🇳🇬" },
  { code: "KE", name: "Kenya",           currency: "KES", dial: "+254", flag: "🇰🇪" },
  { code: "RU", name: "Russia",          currency: "RUB", dial: "+7",   flag: "🇷🇺" },
  { code: "PL", name: "Poland",          currency: "PLN", dial: "+48",  flag: "🇵🇱" },
  { code: "CZ", name: "Czech Republic",  currency: "CZK", dial: "+420", flag: "🇨🇿" },
  { code: "GR", name: "Greece",          currency: "EUR", dial: "+30",  flag: "🇬🇷" },
];

export const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES.map(c => [c.code, c]));

export function countryOf(code) {
  return COUNTRY_BY_CODE[code] || COUNTRIES[0]; // fallback: India
}

// Currencies we can actually charge (must exist in currency_rates on the backend)
export const CHARGEABLE_CURRENCIES = ["INR", "USD", "EUR", "GBP", "CAD", "AUD", "SGD", "AED"];
